import { forceVisible } from 'react-lazyload';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import PageActions from 'app/store/page/page.actions';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectFilter } from 'app/store/page/page.selectors';
// Components
import { Switch } from 'app/components/Mui';
// i18next
import { useTranslation } from 'react-i18next';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';

const AdditionalBatchesOnly = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const trialMode = useAppSelector(selectTrialMode);
  const filter = useAppSelector(selectFilter);

  const handleChange = (_:any, checked:boolean) => {
    dispatch(PageActions.setFilter('additionalBatchesOnly', checked));
    dispatch(PagesToolbarActions.clearSelectedPages());
    forceVisible();
  }

  if ( trialMode ) return null;
  return (
    <Switch
      sx={{ pt: 0 }}
      label={t('pages.workspace.additionalBatchesOnly')} value={filter.additionalBatchesOnly} name="additionalBatchesOnly"
      onChange={handleChange}
    />
  )
}

export default AdditionalBatchesOnly;
